<template>
  <div class="rules">
    <h3>Routing Rules</h3>
    <p>
      Rules are evalulated from top to bottom and the first rule that matches it
      the one that is applied.
    </p>
    <ul>
      <li>
        For the operators =, &lt;, and &gt; when evaluating a string value they
        will use the string's lenght.
      </li>
      <li>
        Date formatting: mm/dd/yyyy, yyyy/mm/dd, April 5th, 2030, next Sunday,
        20 days from now, today, 18 years before now
      </li>
    </ul>

    <i
      v-if="routingRules.length == 0"
      class="fa fa-plus-square-o mr1 pointer"
      @click="addField()"
    ></i>

    <div class="field" v-for="(rule, index) in routingRules" :key="index">
      <label class="label">Rule #{{ index + 1 }}</label>
      <div class="columns">
        <div class="column is-1 field-options">
          <i
            class="fa fa-angle-up mr1 pointer"
            v-if="index != 0"
            @click="moveUp(index)"
          ></i>
          <i
            class="fa fa-angle-down pointer"
            v-if="index != routingRules.length - 1"
            @click="moveDown(index)"
          ></i>
        </div>
        <div class="column is-2">
          <div class="select">
            <select v-model="rule['attribute']">
              <option v-for="attr in attributes" :value="attr">{{
                attr
              }}</option>
            </select>
          </div>
        </div>
        <div class="column is-2 field-options">
          <div class="select">
            <select v-model="rule['operator']">
              <option
                v-for="op in operatorsForAttribute(rule['attribute'])"
                :value="op"
                >{{ op }}</option
              >
            </select>
          </div>
        </div>

        <div class="column">
          <div class="control field-options">
            <input type="text" :class="['input']" v-model="rule['value']" />
          </div>
        </div>

        <div class="column is-3">
          <div class="select">
            <select v-model="rule['skipTo']">
              <option value="">Skip to...</option>
              <option v-for="page in pages" :value="page.id" :key="page.id">
                {{ page.attributes.title }}
              </option>
              <option disabled value="">--Alternate Endings:--</option>
              <option
                v-for="alternate_ending in alternateEndings"
                :value="alternate_ending.id"
                :key="alternate_ending.id"
              >
                {{ alternate_ending.attributes.alternateEndingHeader }}
              </option>
              <option disabled value="">--Default Ending:--</option>
              <option value="summary">Review and Submit</option>
            </select>
          </div>
        </div>

        <div class="column is-1 field-options">
          <i class="fa fa-plus-square-o mr1 pointer" @click="addField()"></i>
          <i
            class="fa fa-minus-square-o pointer"
            @click="removeField(index)"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  name: "RoutingRules",
  props: ["value", "routingMeta", "question"],

  computed: {
    routingRules: {
      get() {
        return this.value;
      },
      set(routingRules) {
        this.value = routingRules;
        this.$emit("input", routingRules);
      }
    },
    attributes() {
      return Object.keys(this.routingMeta.attributes);
    },
    pages() {
      const pages = this.$store.state.interview.pages;
      return _.filter(pages, o => o.id !== this.question.interviewPageId);
    },
    alternateEndings() {
      const alternateEndings = this.$store.state.interview.alternateEndings;
      return alternateEndings;
    }
  },
  methods: {
    operatorsForAttribute(attribute) {
      return (this.routingMeta.attributes[attribute] || {})["operators"] || [];
    },
    addField() {
      let index = this.routingRules.length;
      this.routingRules.splice(index + 1, 0, {
        attribute: "",
        operator: "=",
        value: "",
        skipTo: ""
      });
      this.$emit("input", this.routingRules);
    },
    removeField(index) {
      this.routingRules.splice(index, 1);
      this.$emit("input", this.routingRules);
    },
    moveUp(index) {
      let ruleToMove = this.routingRules.splice(index, 1);
      this.routingRules.splice(index - 1, 0, ruleToMove[0]);
    },

    moveDown(index) {
      let ruleToMove = this.routingRules.splice(index, 1);
      this.routingRules.splice(index + 1, 0, ruleToMove[0]);
    }
  },

  mounted() {}
};
</script>

<style scoped lang="scss"></style>
